module.exports = __webpack_public_path__ + "static/media/13.2de4adc0.jpeg";